import { render, staticRenderFns } from "./AppListDetail.vue?vue&type=template&id=8bae7294&scoped=true"
import script from "./AppListDetail.vue?vue&type=script&lang=js"
export * from "./AppListDetail.vue?vue&type=script&lang=js"
import style0 from "./AppListDetail.vue?vue&type=style&index=0&id=8bae7294&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bae7294",
  null
  
)

export default component.exports